import _ from 'lodash'

export const getWealthSource = (state) => _.get(state, 'wealthInfo.dataSource')
export const getSalePermission = (state) => _.get(state, 'wealthInfo.isValidSalePermission')
export const getFundList = (state) => _.get(state, 'myWealthProfile.fundList')
export const getFundListLSTU = (state) => _.get(state, 'myWealthProfile.fundListLSTU.fundList')
export const getIsOpenedPDF = (state) => state.wealthInfo.isOpenedPDF
export const getIsOpenedLSTUPDF = (state) => state.wealthInfo.isOpenedLSTUPDF
export const getPremiumPrefill = (state) => _.get(state, 'myWealthProfile.premiumPrefill')
